import { Outlet, useRouteError } from 'react-router';
import { useTranslation } from 'react-i18next';
import { OidcProtectedComponent, useOidc } from '@nohara/react-oidc';

import { ContentLayout } from '@/components/layouts';
import { paths } from '@/config/paths';
import { LoadingScreen } from '@/components/ui';
import { useUser } from '@/features/users';

export const ErrorBoundary = () => {
  const { t } = useTranslation();
  const error = useRouteError();

  console.error(error);

  return <ContentLayout title={t('common.errors.somethingWentWrong')}>Error</ContentLayout>;
};

const AppRoot = () => {
  const { userId } = useOidc();
  // pre load the user data
  useUser(userId);

  return (
    <OidcProtectedComponent redirectTo={paths.auth.login.path} fallbackElement={<LoadingScreen />}>
      <Outlet />
    </OidcProtectedComponent>
  );
};

export default AppRoot;
